import { useState, useEffect } from "react";
import InputNumber from "../../../../../../../shared/components/inputs/InputNumber/InputNumber";
import InputText from "../../../../../../../shared/components/inputs/InputText/InputText";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useLoading } from "../../../../../../../shared/context/LoadingContext";
import toast from "react-hot-toast";
import InputSelect from "../../../../../../../shared/components/inputs/InputSelect/InputSelect";

import { fixSpaces } from "../../../../../../../shared/util/helperFunctions";
import "./ModalEntradaDebito.scss";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

import moment from "moment";

const formasPagamento = [
  "Dinheiro",
  "Cheque",
  // "Cheque Visado",
  // "Transferência de crédito",
  "Internet banking",
  // "Cartão do banco",
  // "Débito direto da conta bancária",
  "Cartão de crédito",
  // "Cartão de débito",
];

function ModalEditarEntradaDebito({
  openModalEditarEntrada,
  handleCloseModalEditarEntrada,
  sendRequest,
  clinicaId,
  entrada,
  updateEntradas,
  auth,
  emitirDocEletronicoEntradas,
  cliente,
  modoContingenciaAtivo,
}) {
  const { startLoading, stopLoading } = useLoading();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openModal, setOpenModal] = useState(openModalEditarEntrada);
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState(0);
  const [observacao, setObservacao] = useState("");
  const [categoria, setCategoria] = useState();
  const [categorias, setCategorias] = useState([]);
  const [caixa, setCaixa] = useState();
  const [caixas, setCaixas] = useState([]);
  const [permCaixas, setPermCaixas] = useState([]);
  const [metodoPagamento, setMetodoPagamento] = useState("Dinheiro");

  // Adicionar estados para o diálogo de confirmação
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [pendingEmit, setPendingEmit] = useState(null);

  //CHEQUE DADOS
  const [numero, setNumero] = useState("");
  const [banco, setBanco] = useState("");
  const [dataCheque, setDataCheque] = useState(moment());
  const [nrConta, setNrConta] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const [categoriasResponse, caixasResponse] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasfinanceiro/clinica/entrada/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
        ]);

        // Process categorias
        const categoriasFormatted = categoriasResponse.categoriasFinanceiro.map(
          (cat) => ({
            id: cat.id,
            value: cat.categoria,
          })
        );

        //Verificar se a categoria ja foi desativada ou não
        //Se sim, adicionamo-la à lista de categorias pois se trata de uma edição
        const isCategoriaActive = categoriasFormatted.find(
          (catF) => catF.id === entrada.categoria._id
        );
        if (!isCategoriaActive) {
          categoriasFormatted.push({
            id: entrada.categoria._id,
            value: entrada.categoria.categoria,
          });
        }

        setCategorias(categoriasFormatted);
        setCategoria(categoriasFormatted[0]?.id);

        // Process caixas
        const caixasFormatted = caixasResponse.caixas.map((cai) => ({
          id: cai.id,
          value: cai.caixa,
        }));

        //Verificar se a caixa ja foi desativada ou não
        //Se sim, adicionamo-la à lista de caixas pois se trata de uma edição
        const isCaixaActive = caixasFormatted.find(
          (caiF) => caiF.id === entrada.caixa._id
        );
        if (!isCaixaActive) {
          caixasFormatted.push({
            id: entrada.caixa._id,
            value: entrada.caixa.caixa,
          });
        }

        const caixaClinica = caixasFormatted.filter(
          (c) => c.value === "Clínica"
        );

        setCaixas(caixaClinica);
        setCaixa(caixaClinica[0].id);
        setPermCaixas(caixasFormatted);

        setValor(entrada.valor);
        setDescricao(entrada.descricao);
        setObservacao(entrada.observacao || "");
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [clinicaId, sendRequest, auth.token]);

  useEffect(() => {
    setOpenModal(openModalEditarEntrada);
  }, [openModalEditarEntrada]);

  const descricaoChangeHandler = (value) => {
    setDescricao(value);
  };

  const valorChangeHandler = (value) => {
    setValor(value);
  };

  const editarEntradaHandler = async (emit) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("tipoEntrada", "reembolso");

      formData.append("observacoes", observacao);
      formData.append("descricao", fixSpaces(descricao));
      formData.append("valor", valor);
      formData.append("categoria", categoria);
      formData.append("atualizadoPor", auth.userId);

      formData.append("cliente", cliente.id);
      formData.append("entradaRecebida", true);
      formData.append("recebidoPor", auth.userId);
      formData.append("caixa", caixa);
      formData.append("metodoPagamento", metodoPagamento);

      if (metodoPagamento === "Cheque") {
        //DADOS CHEQUE
        formData.append("banco", banco);
        formData.append("dataCheque", dataCheque);
        formData.append("nrCheque", numero);
        formData.append("nrContaCliente", nrConta);
      }

      //LEMBRA DE ADICIONAR COMPROVATIVO MAIS TARDE
      const entradaAtualizada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/${entrada._id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      if (emit) {
        emitirDocEletronicoEntradas(
          entradaAtualizada.entrada,
          null,
          "FRE",
          "atualizar"
        );
      } else {
        toast.success("Entrada atualizada e recebida com sucesso!");
        updateEntradas(entradaAtualizada.entrada, "atualizar");
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      handleCloseModalEditarEntrada();
      setIsSubmitting(false);
    }
  };

  const metodoPagamentoChangeHandler = (valor) => {
    setMetodoPagamento(valor);
    if (valor === "Dinheiro") {
      const caixaClinica = permCaixas.filter((c) => c.value === "Clínica");
      setCaixas(caixaClinica);
      setCaixa(caixaClinica[0].id);
    } else {
      const caixasSemClinica = permCaixas.filter((c) => c.value !== "Clínica");
      const caixaClinica = permCaixas.find((c) => c.value === "Clínica");
      setCaixas(caixasSemClinica);
      if (caixa === caixaClinica?.id) setCaixa(caixasSemClinica[0]?.id);
    }
  };

  const preGuardarEntradaHandler = (e, emit) => {
    if (valor === 0 || valor < 0) {
      toast.error("O valor da entrada não pode ser 0 ou menor que 0.");
    } else if (!descricao || descricao.trim() === "") {
      toast.error("Introduza a descrição");
    } else if (!cliente) {
      toast.error("Escolha o Cliente");
    } else if (!categoria) {
      toast.error("Introduza uma categoria");
    } else if (!caixa) {
      toast.error("Introduza uma categoria");
    } else if (!isSubmitting) {
      if (emit && cliente?.nome !== cliente?.nomeFiscal) {
        // Guardar a operação pendente e mostrar o diálogo
        setPendingEmit(emit);
        setConfirmDialogOpen(true);
      } else {
        // Prosseguir normalmente
        setIsSubmitting(true);
        editarEntradaHandler(emit);
      }
    }
  };

  // Handlers para o diálogo
  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
    setPendingEmit(null);
  };

  const handleConfirmDialogConfirm = () => {
    setConfirmDialogOpen(false);

    // Executar a operação pendente
    if (pendingEmit) {
      setIsSubmitting(true);
      editarEntradaHandler(pendingEmit);
    }

    setPendingEmit(null);
  };

  const numeroChangeHandler = (value) => {
    setNumero(value);
  };

  const contaClienteChangeHandler = (value) => {
    setNrConta(value);
  };

  const bancoChangeHandler = (value) => {
    setBanco(value);
  };

  return (
    <>
      <Modal
        open={openModal}
        onClose={handleCloseModalEditarEntrada}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box adicionar-entrada__modal"
          id="modal__adicionar-entrada"
        >
          <h1 className="fluxo-atendimento__modal__titulo">
            Editar entrada - {entrada.descricao}
          </h1>
          {/* {entrada && ( */}
          <div className="adicionar-entrada__modal__container">
            <InputText
              className="adicionar-entrada__modal__container--span2"
              label="Descrição *"
              initialValue={descricao}
              handleChange={descricaoChangeHandler}
            />

            <InputNumber
              className="adicionar-entrada__modal__container--span1"
              label="Valor *"
              initialValue={valor}
              handleChange={valorChangeHandler}
            />

            <InputSelect
              className="adicionar-entrada__modal__container--span1"
              label="Forma de pagamento"
              initialValue={metodoPagamento}
              handleChange={metodoPagamentoChangeHandler}
              items={formasPagamento}
            />

            {categorias && categoria && (
              <div className="customInputContainer adicionar-entrada__modal__container--span2">
                <select
                  onChange={(e) => setCategoria(e.target.value)}
                  className="customInputSelect"
                  value={categoria}
                >
                  {categorias &&
                    categoria &&
                    categorias.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">Categoria</label>
              </div>
            )}

            {caixas && caixa && (
              <div className="customInputContainer adicionar-entrada__modal__container--span2">
                <select
                  onChange={(e) => setCaixa(e.target.value)}
                  className="customInputSelect"
                  value={caixa}
                >
                  {caixas &&
                    caixa &&
                    caixas.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">Caixa</label>
              </div>
            )}

            {metodoPagamento === "Cheque" && (
              <>
                <InputNumber
                  key="numeroCheque"
                  id="numeroCheque"
                  initialValue={0}
                  label="Número Cheque*"
                  handleChange={numeroChangeHandler}
                />

                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DesktopDatePicker
                    className="valorDataCaixa__fields--field muiDatePicker"
                    label="Data*"
                    inputFormat="DD-MM-YYYY"
                    value={dataCheque}
                    onChange={(value) => setDataCheque(value)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>

                <InputText
                  initialValue={nrConta}
                  label="Conta do cliente*"
                  handleChange={contaClienteChangeHandler}
                  notEmpty={true}
                  id="contaDoCliente"
                />
                <InputText
                  initialValue={banco}
                  label="Banco*"
                  handleChange={bancoChangeHandler}
                  notEmpty={true}
                  id="banco"
                />
              </>
            )}

            <textarea
              cols="30"
              rows="7"
              placeholder="observacao"
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              className="adicionar-entrada__modal__container__textarea"
            ></textarea>
          </div>

          <div className="fluxo-atendimento__modal__bottom_btns">
            <span
              className="cancel-btn"
              onClick={handleCloseModalEditarEntrada}
              style={{ display: "block" }}
            >
              Fechar
            </span>

            <span
              disabled={isSubmitting}
              className="blue-button"
              onClick={preGuardarEntradaHandler}
            >
              {isSubmitting ? "Recebendo..." : "Receber"}
            </span>
            {/* Não dá para colocar guardar e emitir fre pois não posso colocar o campo metodoPagamento e dataPagamento numa modal que o usuário pode simplismente estar a guardar para não receber*/}
            <span
              disabled={isSubmitting}
              className={"blue-button"}
              onClick={preGuardarEntradaHandler.bind(null, null, "emitirFRE")}
            >
              {isSubmitting
                ? "Recebendo..."
                : `Receber e emitir FRE ${
                    modoContingenciaAtivo ? " (Contingência)" : ""
                  }`}
            </span>
          </div>
        </Box>
      </Modal>
      <Dialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">
          Atenção: Nomes diferentes
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            O nome do cliente ({cliente?.nome}) e o nome fiscal (
            {cliente?.nomeFiscal}) são diferentes. Deseja prosseguir com a
            emissão do documento?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmDialogClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmDialogConfirm}
            color="primary"
            autoFocus
          >
            Prosseguir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ModalEditarEntradaDebito;
